<div class="flex flex-col w-full gap-1">
    @if (isLoading) {
        <div class="p-2">
            <busy-spin></busy-spin>
        </div>
    } @else if (decks?.length) {
        @if (isMobileScreen()) {
            <div class="grid grid-cols-2 gap-1">
                @for (deck of decks ; track deck.id) {
                    <magic-set-decks-row [deck]="deck" class="rounded shadow"></magic-set-decks-row>
                }
            </div>
        } @else {
            @for (deck of decks ; track deck.id) {
                <magic-set-decks-row [deck]="deck" class="rounded shadow"></magic-set-decks-row>
            }
        }
    }
</div>